export default "__VITE_ASSET__Bje7vhUW__"